import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { GridRowId } from '@mui/x-data-grid';
import { InsurersType, ReleasableHoldReasons } from './bill-management-types';

// ACCOUNTS-AND-PLAN-MIGRATION: insurerId here is the hold change-to target identity, not resolvable via contract_id — will be addressed by the Accounts & Plan migration.
export interface InsurerCellProps {
  insurers: InsurersType[];
  holdType?: string;
  insurerId?: string;
  id: GridRowId;
  name?: string;
  loading?: boolean;
}
export const InsurerCell = ({
  insurers,
  holdType,
  insurerId,
  id,
  name,
  loading,
}: InsurerCellProps): JSX.Element => {
  if ((!id && !name) || loading) {
    return <HHTypography hhVariant="caption">Loading...</HHTypography>;
  }

  return (
    <HHStack>
      {id &&
      insurerId &&
      !loading &&
      insurers.length >= 1 &&
      holdType === ReleasableHoldReasons.CARRIER_CHANGE ? (
        <HHStack>
          <HHTypography
            hhVariant="variant-bypass"
            variant="caption"
            sx={{ textDecoration: 'line-through', color: 'gray' }}
          >
            {name}
          </HHTypography>
          <HHTypography hhVariant="caption">
            {
              insurers.filter(insurer => insurer.id === parseInt(insurerId))[0]
                .name
            }
          </HHTypography>
        </HHStack>
      ) : (
        <HHTypography hhVariant="caption">{name}</HHTypography>
      )}
    </HHStack>
  );
};
